module.exports = __webpack_public_path__ + "img/compliant-gdpr-fr.6d02c6a0.png";